import { CONTACT_ADDRESS_LINES, CONTACT_CHANNELS } from '../../data/contact';
import './ContactDetails.css';

const isExternal = (href) => href.startsWith('https://');

/** @param {{ channel: import('../../data/contact').ContactChannel }} props */
function ChannelLink({ channel }) {
  const { value, href } = channel;
  const externalProps = isExternal(href) ? { target: '_blank', rel: 'noreferrer' } : {};

  return (
    <a href={href} {...externalProps}>
      {value}
    </a>
  );
}

/** WhatsApp, Telegram, email and address list shared by the footer and the Locations page. */
export default function ContactDetails() {
  return (
    <dl className="contact-details">
      {CONTACT_CHANNELS.map((channel) => (
        <div key={channel.id} className="contact-details__item">
          <dt>{channel.label}</dt>
          <dd>
            <ChannelLink channel={channel} />
          </dd>
        </div>
      ))}
      <div className="contact-details__item contact-details__item--address">
        <dt>Address</dt>
        <dd>
          <address>
            {CONTACT_ADDRESS_LINES.map((line, index) => (
              <span key={line}>
                {index > 0 && <br />}
                {line}
              </span>
            ))}
          </address>
        </dd>
      </div>
    </dl>
  );
}
